import { render, staticRenderFns } from "./MapPopup.vue?vue&type=template&id=8470044a&scoped=true"
import script from "./MapPopup.vue?vue&type=script&lang=js"
export * from "./MapPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8470044a",
  null
  
)

export default component.exports